import React from "react";
// @ts-ignore
import {Link as RouterLink} from "react-router-dom";
// @ts-ignore
import {Row} from 'shards-react';
import Colors from "../../../assets/colors/Colors";
import Images from "../../../assets/images/Images";

import SocialMediaHeader from "./HeaderComponents/SocialMediaHeader";
import LanguageSelector from "./HeaderComponents/LanguageSelector";
import Constants from "../../../data/Constants";
import './HeaderStyle.css'

const Logos: React.FC = () => {
    const studioStyle = { height: 25, display: 'block', margin: 'auto 0'};
    const mainLogoStyle = { height: 20, margin: 'auto 0' };

    return (
        <RouterLink to={Constants.routes.root} className='logoContainer'>
            <img src={Images.logoMapfreWhite} alt="MAPFRE Logo" style={mainLogoStyle} />
        </RouterLink>
    )
};

const LayoutHeader: React.FC = () => {
    const socialMediaContainerStyle = {flex: 6, marginRight: '2%'};

    return (
        <Row
            id='HEADER'
            style={{
                height: Constants.values.headerHeight,
                minHeight: 50,
                backgroundColor: Colors.headerNavigationRed
            }}>
            <Logos />
            <div className='socialLanguageContainer'>
                <SocialMediaHeader customStyle={socialMediaContainerStyle}/>
                <LanguageSelector />
            </div>

        </Row>
    )
};

export default LayoutHeader;
